export var ColorType;
(function (ColorType) {
    ColorType["Rgb"] = "rgb";
    ColorType["Pantone"] = "pantone";
    ColorType["Cmyk"] = "cmyk";
    ColorType["Cmyka"] = "cmyka";
    ColorType["Rgba"] = "rgba";
})(ColorType || (ColorType = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZGVzaWduSWRlbnRpdHkuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvdHlwZXMvYnJhbmRDb21wb25lbnRzL2Rlc2lnbklkZW50aXR5LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQTRCQSxNQUFNLENBQU4sSUFBWSxTQU1YO0FBTkQsV0FBWSxTQUFTO0lBQ25CLHdCQUFXLENBQUE7SUFDWCxnQ0FBbUIsQ0FBQTtJQUNuQiwwQkFBYSxDQUFBO0lBQ2IsNEJBQWUsQ0FBQTtJQUNmLDBCQUFhLENBQUE7QUFDZixDQUFDLEVBTlcsU0FBUyxLQUFULFNBQVMsUUFNcEIifQ==